import { Button, ButtonProps } from "@chakra-ui/react";
import { cn } from "utils/helpers";

interface FuncButtonProps extends ButtonProps {
	isActive?: boolean;
}

const FuncButtonStyled: React.FC<FuncButtonProps> = ({
	className,
	children,
	isActive = false,
	...props
}) => {
	return (
		<Button
			className={cn(
				"flex h-[40px] items-center gap-2 self-center rounded-[4px] border border-[#D0D5DD] bg-white px-4 py-2 font-roboto text-sm font-semibold leading-[1.5] text-secondary-700 shadow-input hover:bg-gray-50 focus:ring-2 focus:ring-ring-blue-primary",
				isActive &&
					"border-utility-brand-300 !text-royal-blue ring-2 !ring-ring-blue-primary",
				className
			)}
			{...props}
		>
			{children}
		</Button>
	);
};

export default FuncButtonStyled;
